import { Tag, Content } from 'containers/TextAnalysis/Types'

export type VariantTypes =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'subtitle1'
  | 'subtitle2'
  | 'body'
  | 'body1'
  | 'body2'
  | 'caption'
  | 'button'
  | 'overline'
  | 'inherit'

export type ActionCardProps = {
  /* Props related to card appearance */
  id?: number | string
  index?: number
  elevate?: number
  hover?: boolean
  innerRef?: ((instance: HTMLDivElement | null) => void) | null

  /* Props related to content */
  cardMeta?: string | HTMLElement | JSX.Element | null
  cardTitle?: string | HTMLElement | JSX.Element | null
  cardTitleLink?: string | HTMLElement | JSX.Element | null
  cardContent?: string | HTMLElement | JSX.Element | null
  cardTags?: object[] | React.ReactNode | any
  cardTagMenu?: string | HTMLElement | JSX.Element | null
  cardActions?: string | HTMLElement | JSX.Element | null
  cardMetrics?: string | object | object[] | HTMLElement | JSX.Element | null
  cardMetricsVariant?: VariantTypes
  anchorElMap?: { [key: number]: HTMLElement | null } | any

  /* Checkbox and additional props */
  showCheckbox?: boolean
  $checked?: boolean
  showAddTag?: boolean
  handleCheckboxClick?: (e: any) => any
  handleIdeasCommentTitleClick?: () => any
  onClickAddTag?: () => void
  onFocus?: () => void
  onBlur?: () => void
  onMouseLeave?: () => void
  $focused?: boolean
  sx?: object[] | object
  additionalProps?: any
}

export const DefaultProps: Partial<ActionCardProps> = {
  elevate: 0,
  hover: false,
  showCheckbox: false,
  showAddTag: false,
  cardMetricsVariant: 'caption',
}

export const CheckboxProps = {
  inputProps: { 'aria-label': 'ActionCard-CardCheckbox' },
}

export type TextAnalysisStateProps = {
  data: TAResponseProps[]
  total: number
  tags: {
    tagsList: object[]
    fetchingTags: boolean
    doneFetchingTags: boolean
    fetchTagsError: string
  }
  selectedContributions: TAResponseProps[]
  allContributions: {
    fetching: boolean
    doneFetching: boolean
    fetchError: string
  }
  createContributionTags: {
    creatingTags: boolean
    doneCreatingTags: boolean
    creatingTagsError: boolean
  }
  updateContributionTags: {
    updatingTags: boolean
    doneUpdatingTags: boolean
    updatingTagsError: boolean
  }
  contributions: {
    loading: boolean
    bulkUpdate: {
      pending: boolean
      done: boolean
      error: string
    }
    singleContribution: {
      pending: boolean
      done: boolean
      error: string
      data: object
    }
  }
  queries: {
    page: number
    per_page: number
    search?: object
  }
  userFilters: { [key: string | number]: any }
  hasUserFiltersUpdated: boolean
}

export type TAResponseProps = {
  id: string
  contents: Content[]
  source_type: string
  source_id: string
  references: object[] | object | any
  metadata: {
    created_at: string
    updated_at: string
    comments_count: number
    likes_count: number
  }
  associations: {
    owner: {
      id: number
      type: string
      name: string
    }
    parent: {
      id: number
      type: string
      name: string
    }
    project: {
      id: number
      type: string
      name: string
    }
    user: {
      id: number
      type: string
      name: string
    }
  }
  tags: Tag[]
}

export type TagMenuProps = {
  id?: string | undefined
  tags: (string | object)[]
  [tagLabel: string]: any
  open: boolean
  showHelpText?: boolean
  allowCreateTag?: boolean
  label?: string
  placeholder?: string
  anchorEl?: HTMLElement | null
  onCloseTagMenu: (
    selectedTags: (string | Tag)[],
    tagsChangedStatus: boolean,
  ) => void
  onAddTagToContribution: (type: string, tagToAdd: (string | Tag)[]) => void
  onTagDelete: (tag: any) => void
}

export type CardPaginationProps = {
  count: number
  page: number
  pageSize: number
  onPageChange: (newPage: number) => void
  onRowsPerPageChange: (pageSize: number) => void
  clearBulkSelect: boolean
}

export const ELLIPSIS_LENGTH = 3

export const PaginationRowsOptions = [10, 20, 30]

export type MouseEvent = React.MouseEvent<HTMLButtonElement> | null

export type ChangeEvent = React.ChangeEvent<
  HTMLInputElement | HTMLTextAreaElement
>

export const SEARCH_WORD_LIMIT = 250
